import axios from "axios";

export class waiter
{
    constructor(session) {
        this.user = session ? session.user : null;
        this.id_company = session ? session.id_company : null;
        this.id_branch = session ? session.id_branch : null;
        this.token = session ? session.token : null;
        this.id = null;
        this.id_number = null;
        this.name = null;
        this.lastname = null;
        this.lastname_2 = null;
        this.id_user = null;
        this.is_active = true;
        this.created_by = null;
        this.created = null;
        this.modified_by = null;
        this.modified = null;
        this.terminals = null;
        this.is_chasher = false;
        this.nip = null;
        this.have_cancel = false;
        this.have_discount = false;
    }

    async all() {
        let response = await axios.get("tpv/waiter", {
            headers: {
                user: this.user,
                company: this.id_company,
                branch: this.id_branch,
                token: this.token
            }
        });
        return response.data;
    }

    async save() {
        let response = await axios.post("tpv/waiter", this, {
            headers: {
                user: this.user,
                company: this.id_company,
                branch: this.id_branch,
                token: this.token
            }
        });
        return response.data;
    }
}